import React from 'react';
import SubTable from 'src/components/commons/subTable';
import PageContainer from 'src/components/pageContainer/PageContainer';
import { CustomLoadingModal } from 'src/components/commons/customModal';
import useTabBuyingGroupTable from './hooks/useTabBuyingGroupTable';
import StyleInfinityScroll from '../../../../styles/StyleInfinityScroll.style';

const TabBuyingGroupTable = () => {
  const {
    autocompleteFieldSearch,
    handleFilterChange,
    handleSortModelChange,
    handleUpdateRows,
    handleDeleteRows,
    setColumns,
    onListRender,
    dataSource,
    columns,
    queryResponse,
    newRecord,
    postData,
    resetNewRecord,
    createNewRecord,
    handleClearFilter,
  } = useTabBuyingGroupTable();

  return (
    <>
      {queryResponse.loading && <CustomLoadingModal modalStatus />}
      <PageContainer margin='2rem'>
        <StyleInfinityScroll>
          <SubTable
            data={dataSource}
            columns={columns}
            setColumns={setColumns}
            autocompleteFieldProvider={autocompleteFieldSearch}
            onFilterChange={handleFilterChange}
            onSortChange={handleSortModelChange}
            onListRender={onListRender}
            scroll={{ y: '60vh', x: '90vw' }}
            actionCell={['delete']}
            headerActions={['filter', 'edit', 'delete']}
            id='sub-table-buying-group-table-id'
            showOptionFilterLeft={false}
            allowGlobalEditActive
            total
            showAutoIncrement
            handleUpdateRows={handleUpdateRows}
            newRecord={newRecord}
            postData={postData}
            saveNewRecord={createNewRecord}
            resetNewRecord={resetNewRecord}
            clearFilter={handleClearFilter}
            onDeleteClick={handleDeleteRows}
            columnFilterShown
          />
        </StyleInfinityScroll>
      </PageContainer>
    </>
  );
};
export default TabBuyingGroupTable;
